{
  "formLabels": {
    "physicalAddress": "Adresse physique",
    "language": "Langue"
  },
  "profile": {
    "details": "Détails",
    "employment": "Emploi",
    "compliance": "Conformité",
    "suitability": "Adéquation",
    "idVerification": "Preuve d'identité",
    "successMessages": {
      "details": "Les détails personnels du client ont été mis à jour.",
      "employment": "Les détails professionnels du client ont été mis à jour.",
      "compliance": "Les détails de conformité du client ont été mis à jour.",
      "suitability": "Les détails d'adéquation du client ont été mis à jour.",
      "id": "L'identité du client a été mise à jour."
    },
    "fieldValidations": {
      "noEmpty": "Ne peut être vide",
      "phone": "Le numéro de téléphone, le cas échéant, doit comporter 10 chiffres.",
      "canadianNumberValidation": "Le format du numéro de téléphone ne correspond pas à un numéro valide au Canada ou aux États-Unis",
      "primaryEmail": "Le format du courriel doit être correct.",
      "number": "Il doit s'agir d'un nombre",
      "sin": "Le numéro d'assurance sociale doit comporter 9 chiffres.",
      "pleaseEnterValidTaxId": "Veuillez saisir un ID d'impôt valide",
      "addressOutOfJurisdictionMessage": "Nous sommes désolés, l'adresse saisie ne fait pas partie des régions prises en charge ({{ALLOWED_JURISDICTIONS}}).",
      "liquidAssetsRequired": "Les actifs liquides sont requis"
    },
    "helpText": {
      "email": "Courriel : utilisé pour la connexion",
      "phone": "Numéro de téléphone : utilisé pour la connexion"
    }
  },
  "authCredentialsUpdateConfirmation": {
    "email": {
      "title": "Voulez-vous vraiment mettre à jour le courriel du client?",
      "subtitle": "Voulez-vous vraiment mettre à jour le courriel du client? Il devra utiliser ce nouveau courriel la prochaine fois qu'il se connectera à son compte."
    },
    "phone": {
      "title": "Voulez-vous vraiment mettre à jour le numéro de téléphone du client?",
      "subtitle": "Voulez-vous vraiment mettre à jour le numéro de téléphone du client? Il devra utiliser ce nouveau numéro de téléphone la prochaine fois qu'il se connectera à son compte."
    },
    "emailAndPhone": {
      "title": "Voulez-vous vraiment mettre à jour le courriel et le numéro de téléphone du client?",
      "subtitle": "Voulez-vous vraiment mettre à jour le courriel et le numéro de téléphone du client? Il devra utiliser ce nouveau courriel et numéro de téléphone la prochaine fois qu'il se connectera à son compte."
    }
  },
  "confirmationDialog": {
    "title": "Vous allez définir l'identité sur « Non vérifiée »",
    "subtitle": "Cette modification peut nécessiter que le client confirme à nouveau son identité pour pouvoir accéder à l'application destinée aux clients.",
    "continueButton": "Continuer",
    "cancelButton": "Annuler",
    "warning": "Aucune identité n'est vérifiée pour le client"
  },
  "copied": "Copié",
  "details": {
    "trustedContact": {
      "noEmpty": "Ne peut être vide",
      "emailFormatting": "Le format du courriel doit être correct.",
      "phoneFormatting": "Le format du numéro de téléphone doit être correct.",
      "name": "Nom",
      "email": "Courriel",
      "phone": "Numéro de téléphone",
      "address": "Adresse",
      "relation": "Relation",
      "title": "Personne de confiance à contacter",
      "relationOptions": {
        "CHILD": "Enfant",
        "FRIEND": "Ami(e)",
        "GRANDPARENT": "Grand-parent",
        "OTHER": "Autre",
        "PARENT": "Parent",
        "SIBLING": "Frère ou sœur",
        "SPOUSE": "Époux"
      },
      "notAvailableMeta": {
        "header": "Aucune personne de confiance à contacter disponible",
        "body": "Vous pouvez ajouter les coordonnées de la personne de confiance à contacter ici"
      }
    },
    "needsToBeFilled": "À renseigner",
    "placeholders": {
      "issueSource": "Indiquez la source du problème ici",
      "companySymbol": "Indiquez le symbole de l'entreprise ici",
      "registrationNumber": "Indiquez le numéro d'inscription ici",
      "selectAnOption": "Sélectionner une option",
      "selectRiskLevel": "Sélectionnez un nouveau niveau de risque pour le client",
      "note": "Rédiger une note sur la modification"
    },
    "errorMessages": {
      "notSelected": "Non sélectionné",
      "profileIncomplete": "<b>Action requise!</b> Les champs de cette section doivent être renseignés",
      "fieldsToBeFilled": "<b>Action requise!</b> Certains champs doivent être renseignés."
    },
    "profileStatusBox": {
      "header": "État du profil",
      "annualCheckStatusTitle": "État de la vérification annuelle des renseignements",
      "clientAgreementsAreReadyToSignTitle": "Les contrats de clients sont prêts à être signés",
      "approved": "Approuvé",
      "overdue": "En souffrance",
      "lastCheckDate": "Date de mise à jour des renseignements",
      "notAvailableMeta": {
        "header": "Aucun statut de profil disponible",
        "body": "Vous devez ajouter les renseignements requis pour afficher le statut du client."
      }
    },
    "spouseInformationBox": {
      "header": "Renseignements sur l'époux",
      "spouseFirstName": "Prénom",
      "spouseMiddleName": "Deuxième prénom",
      "spouseLastName": "Nom de famille",
      "spouseJobTitle": "Titre du poste",
      "spouseCompanyType": "Type d'entreprise",
      "spouseEmployerName": "Nom de l'employeur",
      "spouseEmploymentType": "Type d'emploi",
      "spouseAddress": "Adresse",
      "spouseEmail": "Courriel",
      "requiredMeta": {
        "header": "Information requise",
        "buttonText": "AJOUTER DES DONNÉES"
      }
    },
    "employmentBox": {
      "header": "Emploi",
      "requiredMeta": {
        "header": "Information requise",
        "buttonText": "AJOUTER DES DONNÉES"
      },
      "employmentStatusTitle": "Situation d'emploi",
      "jobTitle": "Titre du poste",
      "companyTypeTitle": "Type d'entreprise",
      "studentAreaOfStudy": "Domaine d'étude",
      "employerNameTitle": "Nom de l'entreprise",
      "employerCompanyAddressTitle": "Adresse de l'entreprise",
      "employmentSituationTitle": "Situation professionnelle",
      "employmentSituationOtherDescriptionTitle": "Description de la situation professionnelle",
      "previous": {
        "jobTitle": "Titre du poste précédent",
        "companyTypeTitle": "Type de l'entreprise précédente",
        "employerNameTitle": "Nom de l'entreprise précédente",
        "employerCompanyAddressTitle": "Adresse de l'entreprise précédente"
      },
      "taxIdTypeTitle": "Type d'ID d'impôt"
    },
    "entityInformation": {
      "header": "Coordonnées de l'entité",
      "countryOfRegistration": "Pays d'immatriculation",
      "registrationNumber": "Numéro d'immatriculation"
    },
    "riskLevelBox": {
      "header": "Score de risque de criminalité financière : {{riskLevel}}",
      "riskLevel": {
        "0": "Pays ou profession à haut risque",
        "1": "Faible",
        "2": "Moyen",
        "3": "Élevé"
      },
      "notAvailableMeta": {
        "header": "Le niveau de risque ne peut pas être généré",
        "body": "Vous devez compléter le profil du client pour générer le niveau de risque"
      },
      "reason": "Motif",
      "previousChangeQuestion": "Des modifications manuelles ont-elles été ajoutées au niveau de risque précédemment?",
      "overrideExistingLevel": "Remplacer le niveau de risque actuel du client?",
      "newFraudRiskScore": "Nouveau évaluation de risque de fraude",
      "notes": "Notes"
    },
    "idVerificationBox": {
      "header": "Preuve d'identité",
      "addIDVerification": "Ajouter - Preuve d'identité",
      "updateIDVerification": "Mettre à jour - Preuve d'identité",
      "modalBoxPredix": "Créer",
      "idVerifiedLabel": "Identité vérifiée",
      "idNotVerifiedLabel": "Identité non vérifiée",
      "requiredMeta": {
        "header": "Renseignements d'identité requis",
        "buttonText": "AJOUTER DES DONNÉES"
      },
      "typeTitle": "TYPE",
      "jurisdictionTitle": "TERRITOIRE",
      "expiryDate": "DATE D'EXPIRATION",
      "methodOfIdVerification": "MÉTHODE DE VÉRIFICATION DE L'IDENTITÉ",
      "retriggerLabel": "Relancer la vérification de l'identité"
    },
    "clientFeesBox": {
      "header": "Frais du client",
      "requiredMeta": {
        "header": "Information requise",
        "buttonText": "DÉFINIR LES FRAIS"
      },
      "feeGridTitle": "Grille tarifaire",
      "billingCycleTitle": "Cycle de facturation",
      "organizationDefault": "Paramètres par défaut de l'organisation"
    },
    "suitabilityBox": {
      "suitabilityScoreNotAvailableLabel": "Score d'adéquation : non disponible",
      "suitabilityScoreLabel": "Score d'adéquation : {{suitabilityScore}}",
      "requiredMeta": {
        "header": "Le score d'adéquation sera généré après l'ajout des renseignements.",
        "buttonText": "AJOUTER DES DONNÉES"
      },
      "annualIncomeTitle": "Revenu annuel",
      "annualIncomeRangeTitle": "Plage de revenu annuel",
      "totalLiquidAssetsTitle": "Liquidités totales",
      "totalFixedAssetsTitle": "Total des actifs immobilisés",
      "totalDebtTitle": "Dette totale",
      "annualDebtPaymentsTitle": "Paiements annuels des dettes",
      "isAccreditedInvestorTitle": "Investisseur accrédité",
      "investmentKnowledgeTitle": "Connaissances des investissements",
      "riskQuestion1Title": "Question 1 concernant le risque",
      "riskQuestion2Title": "Question 2 concernant le risque",
      "sourceOfWealthTitle": "Source des richesses",
      "sourceOfFundsTitle": "Sources des fonds",
      "uniqueCircumstancesTitle": "Circonstances uniques",
      "none": "Aucun",
      "sourceOfWealthOtherDescriptionTitle": "Description de la source des richesses",
      "sourceOfFundsOtherDescriptionTitle": "Description de la source des fonds"
    },
    "citizenshipAndTaxStatusInformationBox": {
      "individualHeader": "État civil, citoyenneté et situation fiscale",
      "nonIndividualHeader": "Situation fiscale",
      "maritalStatusTitle": "État civil",
      "numberOfDependents": "Nombre de personnes à charge",
      "citizenshipsTitle": "Citoyennetés",
      "countryOfTaxResidenceTitle": "Pays de résidence fiscale",
      "foreignTaxInformationTitle": "Renseignements fiscaux étrangers",
      "countryTitle": "PAYS",
      "taxIdentificationNumberTitle": "NUMÉRO D'IDENTIFICATION FISCALE",
      "taxNumber": "Numéro fiscal",
      "yearEnd": "Date de fin d'exercice"
    },
    "personAndEntitiesOfInterestBox": {
      "header": "Personne et entités concernées",
      "officerOfAPublicCompanyTitle": "Agent d'une entreprise publique",
      "ownerOfPublicCompanyTitle": "Propriétaire d'une entreprise publique",
      "publicCompanySymbol": "Symbole de l'entreprise publique",
      "memberOfIIROCTitle": "Membre de l'OCRCVM",
      "IIROCCompanySymbolTitle": "Symbole de l'entreprise membre de l'OCRCVM",
      "politicallyExposedDomesticPersonTitle": "Personne locale politiquement exposée",
      "politicallyExposedForeignPersonTitle": "Personne étrangère politiquement exposée",
      "closeAssociateOfPEPTitle": "Associé proche d'une PPE",
      "powerOfAttorneyGrantedTitle": "Procuration accordée",
      "complianceStateTitle": "État de conformité",
      "headOfInternationalOrganizationTitle": "Responsable d'organisation internationale",
      "complianceIssueSourceTitle": "Source du problème de conformité",
      "diminishedCapacityTitle": "Capacité réduite",
      "isVulnerablePerson": "Personne vulnérable",
      "isOwnerOfEntity": "Propriétaire de l'entité",
      "isRelatedToAdvisorTitle": "Lié au conseiller"
    },
    "entityOfInterestBox": {
      "header": "Entité concernée",
      "isNonProfitTitle": "Organisme sans but lucratif",
      "receivesDonationsFromPublic": "Sollicite des dons auprès du public",
      "isRegisteredWithCRATitle": "Immatriculation auprès de l'ARC",
      "charityRegistrationNumber": "Numéro d'immatriculation de l'association caritative",
      "isEntityRegulatedTitle": "Réglementé",
      "regulatorNameTitle": "Nom de l'organisme de réglementation",
      "regulatorRegistrationNumber": "Numéro d'immatriculation de l'organisme de réglementation",
      "isReportingIssuerTitle": "Émetteur assujetti",
      "issuerNameTitle": "Nom de l'émetteur",
      "issuerTickerTitle": "Symbole de l'émetteur",
      "issuerExchangeTitle": "Taux de change de l'émetteur",
      "isAFinancialEntityTitle": "Une entité financière ou une entreprise liée",
      "isAffiliateOfFinancialEntityTitle": "Un affilié d'une entité financière",
      "instructionsFromFinancialEntityTitle": "Instructions autorisées par une entité financière",
      "isPublicBodyTitle": "Organisme public",
      "isForThirdPartyTitle": "Pour un tiers",
      "isLargeCorporation": "Très grande entreprise"
    },
    "relationOptions": {
      "CHILD": "Enfant",
      "FRIEND": "Ami(e)",
      "GRANDPARENT": "Grand-parent",
      "OTHER": "Autre",
      "PARENT": "Parent",
      "SIBLING": "Frère ou sœur",
      "SPOUSE": "Époux",
      "COMMON_LAW": "Conjoint de fait",
      "GRANDCHILD": "Petit-enfant",
      "GUARDIAN": "Tuteur",
      "NEPHEW_NIECE": "Neveu/nièce",
      "PRIMARY_CAREGIVER": "Responsable"
    },
    "editClientDetail": "Modifier les détails du client",
    "editNonIndivEntityDetail": "Mettre à jour l'entité non individuelle",
    "riskLevel": "Niveau de risque",
    "idVerification": "Preuve d'identité",
    "firstName": "Prénom",
    "middleName": "Deuxième prénom",
    "lastName": "Nom de famille",
    "allocation": "Allocation",
    "entityName": "Nom de l'entité",
    "clientName": "Nom du client",
    "primaryEmail": "Courriel",
    "phone": "Numéro de téléphone",
    "country": "Pays",
    "province": "Province",
    "city": "Ville",
    "preferredLanguages": "Langue préférée",
    "dateOfBirth": "Date de naissance",
    "dateOfDeath": "Date de décès",
    "establishedDate": "Établi",
    "numClientsInEntity_one": "1 client dans cette entité",
    "numClientsInEntity_other": "{{count}} clients dans cette entité",
    "inProvinceSince": "Dans la province depuis",
    "physicalAddress": "Adresse",
    "gender": "Genre",
    "state": {
      "FROZEN": "Gelé",
      "ACTIVE": "Actif",
      "INACTIVE": "Inactif"
    },
    "stateTooltip": {
      "FROZEN": "Un client gelé ne peut pas effectuer de virements. Cliquez sur le menu avec des points en suspension sur la droite pour faire passer le statut du client sur Actif.",
      "INACTIVE": "Ce client a été définitivement désactivé."
    },
    "idVerificationNotCompletedTooltip": "Ajoutez une preuve d'identité dans l'onglet des détails.",
    "complianceStateNotApprovedTooltip": "Accédez à l'onglet des détails pour approuver les détails de conformité du client.",
    "incompleteProfileTooltip": "Accédez à l'onglet des détails et mettez à jour les renseignements incomplets",
    "allDocumentSigned": "Tous les documents signés",
    "unsignedDocuments_one": "1 document non signé",
    "unsignedDocuments_other": "{{count}} documents non signés",
    "unsignedDocumentsTooltip": "Signez les documents en accédant à l'onglet des documents.",
    "annualInfoUpToDate": "Renseignements annuels mis à jour",
    "annualInfoNeedsReview": "Mise à jour des renseignements annuels",
    "suitabilityReviewOverdue": "Le dernier examen d'adéquation a eu lieu il y {{months}} mois.",
    "complianceStateNeedsReview": "Évaluation des besoins en matière d'état de conformité",
    "annualInfoNeedsReviewTooltip": "Le dernier examen d'aptitude a eu lieu il y a {{months}} mois. Mettez à jour les renseignements du client en cliquant sur le bouton de modification sur le statut du profil, dans l'onglet des détails.",
    "freeze": "Geler",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "deactivationConfirmation": {
      "title": "Voulez-vous désactiver {{clientName}}?",
      "body": "Cette action est irréversible."
    },
    "transitionUser": "Sélectionner une transition",
    "maritalStatus": "État civil",
    "clientsStatus": "Historique des statuts du client",
    "viewClientStatus": "Afficher l'historique des statuts du client",
    "employmentStatus": "Situation d'emploi",
    "jobTitle": "Titre du poste",
    "companyType": "Type d'entreprise",
    "employerName": "Nom de l'entreprise",
    "employerCompanyAddress": "Adresse de l'entreprise",
    "employmentSituation": "Situation professionnelle",
    "relation": "Relation",
    "studentAreaOfStudy": "Domaine d'étude",
    "sin": "NAS",
    "isOfficerOfPublicCompany": "Agent d'une entreprise publique",
    "isOwnerOfPublicCompany": "Propriétaire d'une entreprise publique",
    "isMemberOfIiroc": "Membre de l'OCRCVM",
    "politicallyExposedForeignPerson": "Personne étrangère politiquement exposée",
    "politicallyExposedDomesticPerson": "Personne locale politiquement exposée",
    "closeAssociateOfPEP": "Associé proche d'une PPE",
    "powerOfAttorneyGranted": "Procuration accordée",
    "headOfInternationalOrganization": "Responsable d'organisation internationale",
    "ssSymbols": "Symbole de l'entreprise publique",
    "insiderSymbols": "Symbole de l'entreprise membre de l'OCRCVM",
    "sinPlaceholder": "Non visible, mise à jour uniquement",
    "complianceState": "État de conformité",
    "complianceIssueSource": "Source du problème de conformité",
    "annualIncomeCents": "Revenu annuel",
    "financialLiquidAssetsCents": "Liquidités totales",
    "financialFixedAssetsCents": "Total des actifs immobilisés",
    "totalDebtCents": "Dette totale",
    "annualDebtPaymentsCents": "Paiements annuels des dettes",
    "investmentKnowledge": "Connaissances des investissements",
    "updateGoal": "Mettre à jour l'objectif",
    "addID": "Ajouter - Preuve d'identité",
    "updateID": "Mettre à jour - Preuve d'identité",
    "riskQuestion1": "Question 1 concernant le risque",
    "riskQuestion1Answer": {
      "LEVEL_5": "Maximiser les gains",
      "LEVEL_3": "Les deux également",
      "LEVEL_1": "Minimiser les pertes"
    },
    "riskQuestion2": "Question 2 concernant le risque",
    "riskQuestion2Answer": {
      "LEVEL_4": "Ne rien faire",
      "LEVEL_3": "Retirer un peu d'argent",
      "LEVEL_2": "Retirer un peu d'argent",
      "LEVEL_1": "Retirer tout l'argent",
      "LEVEL_5": "Investir plus"
    },
    "annualInfoNeedsReviewNotice": "Mise à jour annuelle des renseignements",
    "annualInfoNeedsReviewNoticeDetail": "Le dernier examen d'adéquation a eu lieu il y a {{months}} mois.",
    "isRelatedToAdvisor": "Lié au conseiller"
  },
  "editClientOrganization": {
    "moveClientToAnotherOrganization": "Transférer le client dans une autre organisation",
    "currentOrganization": "Organisation actuelle",
    "cannotMoveHouseholdMembers": "Les clients membres d'un ménage ou d'une entreprise ne peuvent pas être déplacés.",
    "confirmationTitle": "Voulez-vous vraiment mettre à jour l'organisation du client?",
    "confirmationSubtitle": "Il sera affecté à la nouvelle organisation, ce qui peut avoir une incidence sur la création de rapports, les portefeuilles et d'autres configurations.",
    "updatedToastMessage": "Le client {{clientName}} a été transféré dans une autre organisation.",
    "selectOrganization": "Sélectionner une organisation"
  },
  "menu": {
    "editProfile": "Modifier le profil",
    "moveToAnotherOrganization": "Transférer dans une autre organisation",
    "copyProfileURL": "Copier l'URL du profil",
    "freezeClient": "Geler le client",
    "copyID": "Copier la pièce d'identité",
    "addToHousehold": "Ajouter à un ménage"
  },
  "form": {
    "update": "Mettre à jour",
    "edit": "Modifier",
    "add": "Ajouter"
  },
  "edit": {
    "goal": {
      "updatedToastMessage": "L'objectif a été mis à jour.",
      "applyPortfolioAtGoal": "Appliquer le portefeuille à l'objectif",
      "noPermissions": "Vous ne disposez pas de l'autorisation nécessaire pour modifier un objectif"
    },
    "buttons": {
      "save": "Enregistrer"
    },
    "complianceStateOptions": {
      "APPROVED": "Approuvé",
      "NEEDS_REVIEW": "Examen requis",
      "REJECTED": "Refusé"
    },
    "debtAssociatedOptions": {
      "MORTGAGE": "Hypothèque",
      "CREDIT_CARD": "Carte de crédit",
      "STUDENT_LOAN": "Prêt étudiant"
    },
    "employmentStatusOptions": {
      "EMPLOYED": "Employé(e)",
      "SELF_EMPLOYED": "Travailleur(euse) autonome",
      "RETIRED": "Retraité(e)",
      "UNEMPLOYED": "Sans emploi",
      "STUDENT": "Étudiant(e)",
      "STAY_AT_HOME_PARENT": "Ménager(e)"
    },
    "fatcaStatus": "Statut FATCA",
    "fatcaStatusOptions": {
      "PUBLICLY_TRADED_NFFE": "NFFE publiquement négociée",
      "INTERNATIONAL_ORGANIZATION": "Organisation internationale",
      "GOVERNMENT": "Gouvernement",
      "CENTRAL_BANK": "Banque centrale",
      "ACTIVE_NFFE": "NFFE active",
      "PASSIVE_NFFE": "NFFE passive",
      "OTHER": "Autre"
    },
    "fatcaStatusOtherDescription": "Autre description du statut FATCA",
    "employmentSituationOptions": {
      "STABLE_AND_SECURE": "Stable et sécuritaire",
      "STABLE_BUT_MAY_CHANGE_IN_FUTURE": "Stable mais peut changer dans le futur",
      "SOMEWHAT_STABLE": "Légèrement stable",
      "UNEMPLOYED_BUT_LOOKING": "À la rechercher d'un emploi",
      "OTHER": "Autre"
    },
    "relationOptions": {
      "CHILD": "Enfant",
      "FRIEND": "Ami(e)",
      "GRANDPARENT": "Grand-parent",
      "OTHER": "Autre",
      "PARENT": "Parent",
      "SIBLING": "Frère ou sœur",
      "SPOUSE": "Époux"
    },
    "scoreOptions": {
      "0": "Pays ou profession à haut risque",
      "1": "Faible",
      "2": "Moyen",
      "3": "Élevé"
    },
    "preferredMethodOfCommunicationOptions": {
      "EMAIL": "Courriel",
      "PHONE": "Numéro de téléphone",
      "TEXT": "Texte",
      "OTHER": "Autre"
    },
    "maritalStatusOptions": {
      "SINGLE": "Célibataire",
      "MARRIED": "Marié(e)",
      "COMMON_LAW": "Conjoint de fait",
      "DIVORCED": "Divorcé(e)",
      "SEPARATED": "Séparé(e)",
      "WIDOWED": "Veuf/veuve",
      "CIVIL_UNION": "Union civile"
    },
    "documentIssuingJurisdicationOptions": {
      "ALBERTA": "Alberta",
      "BRITISH_COLUMBIA": "Colombie-Britannique",
      "MANITOBA": "Manitoba",
      "NEW_BRUNSWICK": "Nouveau-Brunswick",
      "NEW_FOUNDLAND_AND_LABRADOR": "Terre-Neuve-et-Labrador",
      "NOVA_SCOTIA": "Nouvelle-Écosse",
      "ONTARIO": "Ontario",
      "PRINCE_EDWARD_ISLAND": "Île-du-Prince-Édouard",
      "SASKATCHEWAN": "Saskatchewan",
      "QUEBEC": "Québec",
      "YUKON": "Yukon",
      "NORTH_WEST_TERRITORIES": "Territoires du Nord-Ouest",
      "NUNAVUT": "Nunavut",
      "FEDERAL": "Fédéral",
      "OTHER": "Autre"
    },
    "jurisdicationOptionsForUsandCanada": {
      "ALBERTA": "Alberta",
      "BRITISH_COLUMBIA": "Colombie-Britannique",
      "MANITOBA": "Manitoba",
      "NEW_BRUNSWICK": "Nouveau-Brunswick",
      "NEW_FOUNDLAND_AND_LABRADOR": "Terre-Neuve-et-Labrador",
      "NOVA_SCOTIA": "Nouvelle-Écosse",
      "ONTARIO": "Ontario",
      "PRINCE_EDWARD_ISLAND": "Île-du-Prince-Édouard",
      "SASKATCHEWAN": "Saskatchewan",
      "QUEBEC": "Québec",
      "YUKON": "Yukon",
      "NORTH_WEST_TERRITORIES": "Territoires du Nord-Ouest",
      "NUNAVUT": "Nunavut",
      "FEDERAL": "Fédéral",
      "ALASKA": "Alaska",
      "ALABAMA": "Alabama",
      "ARIZONA": "Arizona",
      "ARKANSAS": "Arkansas",
      "CALIFORNIA": "Californie",
      "COLORADO": "Colorado",
      "CONNECTICUT": "Connecticut",
      "DELAWARE": "Delaware",
      "DISTRICT_OF_COLUMBIA": "District de Columbie",
      "FLORIDA": "Floride",
      "GEORGIA": "Géorgie",
      "GUAM": "Guam",
      "HAWAII": "Hawaï",
      "IDAHO": "Idaho",
      "ILLINOIS": "Illinois",
      "INDIANA": "Indiana",
      "IOWA": "Iowa",
      "KANSAS": "Kansas",
      "KENTUCKY": "Kentucky",
      "LOUISIANA": "Louisiane",
      "MAINE": "Maine",
      "MARSHALL_ISLAND": "Îles Marshall",
      "MICHIGAN": "Michigan",
      "MARYLAND": "Maryland",
      "MASSACHUSETTS": "Massachusetts",
      "MINNESOTA": "Minnesota",
      "MISSISSIPPI": "Mississippi",
      "MISSOURI": "Missouri",
      "MONTANA": "Montana",
      "NEBTASKA": "Nebraska",
      "NEVADA": "Nevada",
      "NEW_HAMPSHIRE": "New Hampshire",
      "NEW_JERSEY": "New Jersey",
      "NEW_MEXICO": "Nouveau-Mexique",
      "NEW_YORK": "New York",
      "NORTH_CAROLINA": "Caroline du Nord",
      "NORTH_DAKOTA": "Dakota du Nord",
      "OHIO": "Ohio",
      "OKLAHOMA": "Oklahoma",
      "OREGON": "Oregon",
      "PALAU": "Palaos",
      "PENNSYLVANIA": "Pennsylvanie",
      "PUERTO_RICO": "Porto Rico",
      "RHODE_ISLAND": "Rhode Island",
      "SOUTH_CAROLINA": "Caroline du Sud",
      "SOUTH_DAKOTA": "Dakota du Sud",
      "TENNESSEE": "Tennessee",
      "TEXAS": "Texas",
      "UTAH": "Utah",
      "US_VIRGIN_ISLAND": "Îles Vierges des États-Unis",
      "VERMONT": "Vermont",
      "VIGINIA": "Virginie",
      "WASHINGTON": "Washington",
      "WEST_VIRGINIA": "Virginie-Occidentale",
      "WINSCONSIN": "Wisconsin",
      "WYOMING": "Wyoming",
      "US": "États-Unis",
      "CA": "Canada",
      "OTHER": "Autre"
    },
    "noJurisdication": "S.O.",
    "noJDocumentType": "S.O.",
    "noExpiryDate": "S.O.",
    "methodOfIDVerificationOptions": {
      "CREDIT_CHECK": "Vérification de solvabilité",
      "DIGITAL_DOCUMENT_CHECK": "Vérification de documents numériques",
      "DUAL_METHOD": "Méthode à double processus",
      "IN_PERSON_VALIDATION": "Vérification de la carte d'identité en personne",
      "CONFIRMATION_OF_EXISTENCE": "Confirmation de l'existence"
    },
    "investmentKnowledgeOptions": {
      "NONE": "Aucun",
      "LIMITED": "Limité",
      "SOME": "En partie",
      "EXPERT": "Expert"
    },
    "riskQuestion1Options": {
      "LEVEL_1": "Niveau 1",
      "LEVEL_2": "Niveau 2",
      "LEVEL_3": "Niveau 3",
      "LEVEL_4": "Niveau 4",
      "LEVEL_5": "Niveau 5"
    },
    "riskQuestion2Options": {
      "LEVEL_1": "Niveau 1",
      "LEVEL_2": "Niveau 2",
      "LEVEL_3": "Niveau 3",
      "LEVEL_4": "Niveau 4",
      "LEVEL_5": "Niveau 5"
    },
    "sourceOfWealthOptions": {
      "EMPLOYMENT_INCOME": "Revenu d'emploi",
      "SALE_OF_LARGE_ASSET": "Vente d'actif significatif",
      "PROPERTY_SALE": "Vente de propriété",
      "INHERITANCE": "Héritage",
      "FAMILY_ESTATE": "Succession familiale",
      "INVESTMENT": "Investissement",
      "BUSINESS_OWNERSHIP_INTEREST": "Part dans une entreprise",
      "DEBT": "Dette",
      "LOTTERY_WINNING": "Gain de loterie",
      "OTHER": "Autre"
    },
    "sourceOfFundsOptions": {
      "CONTRIBUTIONS": "Contributions",
      "DEBT": "Dette",
      "DONATIONS": "Dons",
      "EMPLOYMENT_INCOME": "Revenu d'emploi",
      "INCOME_OR_WORKING_CAPITAL": "Revenu issu de fonds de roulement",
      "INHERITANCES_AND_GIFT": "Héritages et cadeau",
      "LOTTERY_WINNING": "Gain de loterie",
      "OTHER": "Autre",
      "PENSION_RELEASE": "Remise à la pension",
      "PERSONAL_SAVINGS": "Économies personnelles",
      "PROCEEDS_FROM_INVESTMENTS": "Produits de placements",
      "PROPERTY_SALE": "Vente de propriété",
      "SALE_OF_LARGE_ASSET": "Vente d'actif significatif",
      "SHARES_SALES_AND_DIVIDENDS": "Ventes et dividendes des actions"
    },
    "typeOfTrustOptions": {
      "COMPLEX": "Fiducie complexe",
      "SIMPLE": "Fiducie simple",
      "GRANTOR": "Fiducie de cédant"
    }
  },
  "tabs": {
    "overview": "Aperçu",
    "details": "Détails",
    "relationships": "Relations",
    "goals": "Objectifs",
    "accounts": "Comptes",
    "agreements": "Accords",
    "documents": "Documents",
    "bankAccounts": "Comptes bancaires",
    "activity": "Activité",
    "performance": "Résultats",
    "profile": "Profil",
    "transfers": "Virements",
    "trades": "Opérations",
    "ledger": "Grand livre",
    "statements": "Relevés",
    "notes": "Notes",
    "audit_log": "Rapport d'activité",
    "organization_user_entities": "Accès"
  },
  "audit": {
    "changedBy": "Modifié par",
    "type": "Type",
    "changedObject": "Objet modifié",
    "changedFields": "Champs modifiés",
    "timestamp": "Estampille temporelle",
    "from": "De",
    "to": "À",
    "field": "Champ",
    "detailDate": "Date",
    "detailTraceId": "Trace",
    "detailObjectIdLabel": "Identifiant {{changedObject}}",
    "detailObjectIdLabelFallback": "id",
    "detailChangedByEmail": "Modifié par",
    "errorLoading": "Impossible de charger le journal d'audit",
    "productName": "Nom du produit",
    "ticker": "Symbole boursier",
    "noClientFound": "Aucun client trouvé",
    "searchFailed": "Impossible de rechercher le client. Veuillez réessayer.",
    "toolbar": {
      "clientSearch": "Recherche de client",
      "apply": "Appliquer",
      "filters": {
        "date": "Sélecteur de date",
        "changedBy": "Modifié par",
        "clientName": "Nom du client",
        "type": "Type",
        "changedObject": "Objet modifié"
      }
    },
    "clientName": "Nom du client",
    "filters": {
      "clientName": "Nom du client",
      "clientNameSearch": "Rechercher des clients",
      "noClientNameOptions": "Aucun client dans les résultats chargés",
      "maxClientNamesSelected": "Un maximum de {{max}} clients peut être sélectionné",
      "type": "Type",
      "maxTypesSelected": "Maximum {{max}} types peuvent être sélectionnés",
      "date": "Date",
      "dateFrom": "De",
      "dateTo": "À",
      "invalidDateRange": "La date de fin doit être égale ou postérieure à la date de début",
      "changedBy": "Modifié par",
      "changedBySearch": "Rechercher par modifié par",
      "noChangedByOptions": "Aucune option de modification par dans les résultats chargés",
      "changedObject": "Objet modifié",
      "changedObjectSearch": "Rechercher l'objet modifié",
      "noChangedObjectOptions": "Aucune option d'objet modifié dans les résultats chargés",
      "maxChangedBySelected": "Un maximum de {{max}} acteurs de modification peut être sélectionné",
      "maxChangedObjectsSelected": "Un maximum de {{max}} objets modifiés peut être sélectionné"
    },
    "inheritedOrgDefault": "Hérité (paramètres par défaut de l'organisation)"
  },
  "userChangesOnly": "Modifications de l'utilisateur uniquement",
  "moreFields": "plus de champs",
  "completed": "Profil complété",
  "notCompleted": "Profil non complété",
  "idVerified": "vérifié",
  "idNotVerified": "non vérifié",
  "suitabilityScore": "Score d'adéquation",
  "theme": "Thème",
  "idTable": {
    "documentId": "Pièce d'identité",
    "documentType": "Type",
    "methodOfIDVerification": "Méthode",
    "documentIssuingJurisdication": "Territoire",
    "documentExpiryDate": "Date d'expiration",
    "verifiedDate": "Vérifié"
  },
  "none": "Aucun",
  "cash": "Trésorerie",
  "accountNumber": "Numéro de compte",
  "accountName": "Nom du compte",
  "subAccountState": {
    "AWAITING_APPROVAL": "Approbation en attente",
    "ACTIVE": "Actif",
    "INACTIVE": "Inactif",
    "PENDING": "En attente",
    "CLOSED": "Fermé"
  },
  "marketValue": "Total des actifs",
  "account": "Compte",
  "subAccount": "Sous-compte",
  "subAccountWithSuffix": "Sous-compte {{suffix}}",
  "accountGroup": "Groupe de comptes",
  "client": "Client",
  "entity": "Entité",
  "clientGroup": "Groupe de clients",
  "goal": "Objectif",
  "groupBy": "Groupe par",
  "security": "Valeur mobilière",
  "primaryAssetClass": "Catégorie d'actifs primaires",
  "secondaryAssetClass": "Catégorie d'actifs secondaires",
  "tertiaryAssetClass": "Classe d'actif tertiaire",
  "ofTotal": "sur la totalité",
  "na": "S.O.",
  "goalTypes": "Type d'objectif",
  "goalName": "Nom de l'objectif",
  "goalType": {
    "CAR": "Voiture",
    "BUILD_WEALTH": "Bâtir vos avoirs",
    "RETIREMENT": "Retraite",
    "MAJOR_PURCHASE": "Achat majeur",
    "HOUSE": "Maison",
    "EDUCATION": "Éducation",
    "VACATION": "Vacances",
    "START_A_BUSINESS": "Lancer une entreprise",
    "WEDDING": "Mariage",
    "PARENTAL_LEAVE": "Congé parental",
    "SAFETY_NET": "Filet de sécurité",
    "OTHER": "Autre",
    "CASH_RESERVE": "Réserve de trésorerie",
    "LEGACY": "Héritage",
    "GROUP": "Groupe",
    "RETIREMENT_INCOME": "Revenu de retraite"
  },
  "accountType": "Type de compte",
  "selectGoal": "Sélectionner l'objectif",
  "editName": "Nom",
  "newIDVerification": "Nouvelle preuve d'identité",
  "methodOfIDVerification": "Méthode de vérification de l'identité",
  "firstDocument": "Premier document",
  "secondDocument": "Deuxième document",
  "noIds": "Aucun document de vérification de l'identité",
  "idVerificationMethods": {
    "CREDIT_CHECK": "Vérification de solvabilité",
    "DIGITAL_DOCUMENT_CHECK": "Vérification de documents numériques",
    "DUAL_METHOD": "Méthode double",
    "IN_PERSON_VALIDATION": "Validation en personne"
  },
  "documentType": "Type de document",
  "documentTypesLabels": {
    "creditCheckDocumentTypes": "Veuillez sélectionner les documents que vous souhaitez joindre",
    "digitalDocumentTypes": "Veuillez sélectionner les documents de vérification numériques que vous souhaitez joindre",
    "dualVerificationTypes": "Veuillez sélectionner les documents de double vérification que vous souhaitez fournir",
    "inPersonVerificationTypes": "Veuillez sélectionner les documents de vérification en personne que vous souhaitez joindre"
  },
  "documentTypes": {
    "BANK_STATEMENT": "Relevé bancaire",
    "BENEFITS_STATEMENT": "Relevé des avantages",
    "BIRTH_CERTIFICATE": "Certificat de naissance",
    "CREDIT_BUREAU": "Bureau de crédit",
    "CAD_CREDIT_BUREAU_PRODUCT": "Produit du bureau de crédit canadien",
    "CANADA_411": "Canada 411",
    "CITIZENSHIP_CARD": "Carte de citoyen",
    "CITIZENSHIP_CERTIFICATE": "Certificat de citoyenneté",
    "CONFIRMATION_FROM_FINANCIAL_ENTITY": "Confirmation de l'entité financière",
    "CREDIT_CARD_STATEMENT": "Relevé de carte de crédit",
    "CREDIT_FILE": "Dossier de crédit",
    "DIVORCE_DOCUMENTATION": "Documents de divorce",
    "DRIVERS_LICENSE": "Permis de conduire",
    "GLOBAL_ENTRY_CARD": "Carte d'entrée globale",
    "GOV_ISSUED_CPP_STATEMENT": "Relevé RPC émis par le gouvernement",
    "GOV_ISSUED_VEHICLE_REGISTRATION": "Immatriculation émise par le gouvernement",
    "HEALTH_CARD": "Carte santé",
    "ID": "Pièce d'identité",
    "INDIAN_STATUS_CARD": "Certificat de statut d'Indien",
    "INSURANCE_DOCUMENT": "Document d’assurance",
    "INVESTMENT_ACCOUNT_STATEMENT": "Énoncé du compte de placement",
    "LOAN_ACCOUNT_STATEMENT": "Relevé de compte de prêts",
    "MARRIAGE_LICENCE": "Permis de mariage",
    "MICRO_DEPOSIT": "Micro-dépôt",
    "MILITARY_ID": "Carte d'identité militaire",
    "NEXUS": "Nexus",
    "OTHER": "Autre",
    "PASSPORT": "Passeport",
    "PERMANENT_RESIDENT_CARD": "Carte de résident permanent",
    "PROCESSED_CHEQUE": "Chèque traité",
    "PROPERTY_TAX_ASSESSMENT": "Évaluation de l'impôt foncier",
    "PROVINCIAL_ID": "Pièce d'identité provinciale",
    "RECORD_OF_EMPLOYMENT": "Dossier d'emploi",
    "SCHOOL_DOCUMENT": "Document scolaire",
    "SOCIAL_SECURITY_CARD": "Carte de sécurité sociale",
    "STATE_ID": "Carte d'identité d'État",
    "TRAVEL_VISA": "Visa de voyage",
    "UTILITY_STATEMENT": "Relevé d'électricité"
  },
  "secondaryDocumentType": "Type de document secondaire",
  "secondaryDocumentIssuingJurisdication": "Territoire d'émission du document secondaire",
  "secondaryDocumentExpiryDate": "Date d'expiration du document secondaire",
  "secondaryDocumentID": "Identifiant du document secondaire",
  "secondaryDocumentUserName": "Identifiant du document secondaire",
  "clientNameOnDocument": "Nom du client sur le document",
  "documentOne": "Document 1",
  "documentTwo": "Document 2",
  "secondaryDocumentName": "Nom du document secondaire",
  "documentName": "Nom du document",
  "documentID": "Identifiant du document",
  "nameOnTheID": "Nom figurant sur la pièce d'identité",
  "creditFileSource": "Source du fichier de crédit",
  "documentIssuingJurisdication": "Territoire d'émission du document",
  "expiryDate": "Date d'expiration du document",
  "verifiedDate": "Date de vérification",
  "selectTheme": "Thème de portefeuille",
  "selectProduct": "Sélectionner un produit",
  "selectModel": "Sélectionner un modèle",
  "requireInvestorPolicyStatement": "Demander un énoncé de politique d'investisseur",
  "allowClientDeposits": "Autoriser les dépôts par le client",
  "timeHorizon": "Horizon temporel",
  "timeHorizonOptions": {
    "VERY_SHORT_TERM": "Moins d'un an",
    "SHORT_TERM": "Dans 1 à 3 ans",
    "MID_TERM": "Dans 4 à 6 ans",
    "LONG_TERM": "Dans 7 ans ou plus",
    "VERY_LONG_TERM": "Très long terme"
  },
  "goalTimeHorizon": {
    "VERY_SHORT_TERM": "Très court terme",
    "SHORT_TERM": "Court terme",
    "MID_TERM": "Moyen terme",
    "LONG_TERM": "Long terme",
    "VERY_LONG_TERM": "Très long terme"
  },
  "targetAmount": "Montant cible",
  "sign": "Signer",
  "review": "Examiner",
  "done": "Terminé",
  "document": "Document",
  "status": "Statut",
  "clientAgreements": "Client",
  "signed": "Signé",
  "notSigned": "Non signé",
  "formPackage": "Lot de formulaire",
  "signingViewPreview": "Aperçu et signature",
  "signingPreviewDialogTitle": "Signer les documents",
  "signingViewUrlMissing": "Le lien de signature n'est pas encore disponible.",
  "formPackStates": {
    "DRAFT": "Brouillon",
    "SENT": "Envoyé",
    "COMPLETED": "Terminé",
    "ARCHIVED": "Archivé",
    "DECLINED": "Décliné",
    "OPTED_OUT": "Refusé",
    "EXPIRED": "Expiré"
  },
  "reviewed": "Examiné",
  "notReviewed": "Non examiné",
  "uploadSigned": "Importer le fichier signé",
  "uploaded": "Importé",
  "pending": "En attente",
  "upload": "Importer",
  "signAndViewNext": "Signer et afficher le suivant",
  "reviewNext": "Examiner le suivant",
  "viewNext": "Afficher le suivant",
  "continue": "Continuer",
  "update": "Mettre à jour",
  "downloadTemplate": "Télécharger le modèle",
  "signAll": "Tout signer",
  "signAllAndContinue": "Tout signer et continuer",
  "signAndContinue": "Signer et continuer",
  "nothingToSign": "Aucun nouveau document à signer",
  "buttons": {
    "addGoal": "Ajouter un objectif",
    "viewPDF": "Afficher le PDF"
  },
  "subAccountModal": {
    "editTitle": "Modifier le sous-compte",
    "addTitle": "Ajouter un nouveau sous-compte",
    "requireInvestorPolicyStatement": "Demander un énoncé de politique d'investisseur",
    "allowFractionalShares": "Autoriser les fractions d'action",
    "liquidated": "Sous-compte liquidé",
    "liquidatedNoTooltip": "Pour modifier le statut de liquidation, lancez un transfert de type retrait intégral.",
    "liquidatedYesTooltip": "Si cette modification est validée, les futurs dividendes ne seront PAS envoyés automatiquement au client."
  },
  "billingModal": {
    "title": "Modifier la facturation du sous-compte",
    "billingCycle": "Cycle de facturation"
  },
  "accountDetails": {
    "transitions": {
      "active": "Transition vers actif",
      "request": "Transition vers demande",
      "fail": "Transition vers échec",
      "cancel": "Transition vers annulation",
      "freeze": "Transition vers gel",
      "ready": "Transition vers prêt",
      "title": "Détails du compte"
    },
    "updateAccNo": "Mettre à jour le numéro de compte",
    "viewStates": "Afficher l'historique des états",
    "asociateAccountToHousehold": "Passer au compte du ménage",
    "asociateAccountToNamedHousehold": "Passer au compte du ménage {{name}}",
    "dissociateAccountFromHousehold": "Dissocier du ménage",
    "closeAccount": "Fermer le compte",
    "forceOpen": "Forcer l'ouverture du compte",
    "forceOpenSuccess": "Le compte sera envoyé au dépositaire en vue de son ouverture dès que les approbations nécessaires auront été obtenues."
  },
  "statements": {
    "custom": "Personnalisé",
    "awaitingReview": "Examen en attente",
    "yearToDate": "Cumul annuel jusqu'à ce jour",
    "reconciled": "Rapproché",
    "allTime": "Depuis toujours",
    "tax": "Impôt",
    "any": "Peu importe",
    "statements": "Relevés",
    "managementFees": "Frais de gestion",
    "failed": "Échoué",
    "lastYear": "L'année dernière",
    "byPeriod": "Par période",
    "fromDate": "De",
    "toDate": "À",
    "typeGroup": "Type",
    "state": "État",
    "accountType": "Type de compte",
    "thereAreNoStatements": "Aucun relevé à afficher"
  },
  "notes": {
    "types": {
      "ORGANIZATIONAL": "Organisationnel",
      "PRIVATE": "Privé",
      "PUBLIC": "Public"
    },
    "subTitile": "Rédiger une note",
    "title": "Notes"
  },
  "documents": {
    "regeneratedToastMessage": "Le PDF a été à nouveau généré.",
    "regenerate": "Générer à nouveau le PDF",
    "title": "Documents",
    "addDocument": "Ajouter un document",
    "searchByName": "Nom du document",
    "typeToSearch": "Type à rechercher",
    "docType": "Type de document",
    "docState": "État",
    "any": "Peu importe",
    "name": "nom",
    "associatedTo": "associé à",
    "dateUpdated": "Date mise à jour",
    "dateSigned": "Date signée",
    "state": "état",
    "PENDING": "En attente",
    "SIGNED": "Signé",
    "SAVED": "Enregistré",
    "signDigitally": "SIGNER NUMÉRIQUEMENT",
    "uploadSignedDocument": "METTRE À JOUR LE DOCUMENT SIGNÉ",
    "downloadTemplate": "TÉLÉCHARGER LE MODÈLE",
    "signConfirmationContent": "Vous allez signer ce document au nom de {{onBehalfOf}}.",
    "signConfimationTitile": "Signer le document",
    "proceedDelete": "Oui, supprimer",
    "cancelDelete": "Non, ne pas supprimer",
    "deleteConfirmationContent": "Voulez-vous vraiment supprimer ce document?",
    "deleteConfirmationTitle": "Supprimer le document",
    "downloadHtmlAsPdf": "Télécharger/imprimer",
    "uploadNewVersion": "Téléverser la nouvelle version",
    "htmlSection": "Document HTML",
    "pdfSection": "Document PDF",
    "allowClientToView": "Permettre au client de consulter le document",
    "preventClientToView": "Ne pas permettre au client de consulter le document",
    "sendToCustodian": "Autoriser le partage du fichier avec le dépositaire",
    "status": "Statut",
    "fileName": "fichier du document",
    "download": "Télécharger",
    "uploadDocument": "IMPORTER LE DOCUMENT",
    "deleteDocument": "Supprimer",
    "previewNotAvailable": "Aperçu non disponible",
    "agreementNotAvailable": "Contrat non disponible",
    "clientName": "Nom du client",
    "type": "Type",
    "cantSignDigitallyPleaseUpload": "Ce document ne peut pas encore être signé numériquement. Veuillez importer un fichier signé à la place.",
    "documentHasBeenUploaded": "Le document a été importé",
    "downloadPdfTemplate": "Télécharger le modèle PDF"
  },
  "documentUpload": {
    "documentUpload": "Importation du document",
    "documentName": "Nom du document",
    "documentType": "Type de document",
    "associatedTo": "Associé à",
    "uploadDocument": "Téléverser le document"
  },
  "droppableFileInput": {
    "dragFilesHere": "Faire glisser et déposer un fichier ici",
    "or": "ou",
    "chooseAFile": "Choisir un fichier",
    "chooseAnotherFile": "En choisir un autre",
    "fileSize": "Taille du fichier",
    "oneFileAtATime": "Un fichier à la fois, s'il vous plaît"
  },
  "clientGroupSummary": {
    "establishedDate": "date d'établissement",
    "client": "client",
    "clients": "clients",
    "inThisGroup": "dans ce groupe",
    "editClientGroupProfile": "modifier le profil du groupe de clients"
  },
  "clientGroupType": {
    "BUSINESS": "Entreprise",
    "HOUSEHOLD": "Famille"
  },
  "goalsSummary": {
    "header": "Objectifs",
    "addGoalBtn": "AJOUTER UN OBJECTIF",
    "ofTargetAmount": "du montant cible",
    "subAccountsLinked_one": "1 sous-compte lié",
    "subAccountsLinked_other": "{{count}} sous-comptes liés",
    "subAccountNeedsApproval_one": "1 sous-compte doit être approuvé",
    "subAccountNeedsApproval_other": "{{count}} sous-comptes doivent être approuvés",
    "goalStateLabel": "État de l'objectif",
    "noGoals": "Vous n'avez pas d'objectifs",
    "goalState": {
      "ACTIVE": "Actif",
      "COMPLETED": "Terminé",
      "ARCHIVED": "Fermé"
    },
    "externalHoldingsLinked_one": "1 actif lié",
    "externalHoldingsLinked_other": "{{count}} actifs liés"
  },
  "accountsSummary": {
    "header": "Comptes",
    "subAccountsLinked_one": "1 sous-compte lié",
    "subAccountsLinked_other": "{{count}} sous-comptes liés",
    "ofTotalAssets": "{{percentage}} de la valeur totale",
    "addAccountBtn": "AJOUTER UN COMPTE",
    "accountStateLabel": "État du compte",
    "noAccounts": "Vous n'avez pas de compte",
    "externalHoldingsLinked_one": "1 actif lié",
    "externalHoldingsLinked_other": "{{count}} actifs liés",
    "repCodeLabel": "Code de représentant",
    "repCodeNotAssigned": "Non attribué"
  },
  "clientReportSummary": {
    "header": "Rapports clients",
    "noReports": "Vous n'avez pas de rapports.",
    "noReportsFiltered": "Aucun rapport ne correspond à vos critères de recherche"
  },
  "holdingsSummary": {
    "noHoldings": "Vous n'avez pas d'avoirs"
  },
  "subAccountsSummary": {
    "header": "Portefeuilles",
    "noSubAccounts": "Vous n'avez pas de portefeuilles"
  },
  "accountsGroup": {
    "tableHeaders": {
      "name": "Nom du groupe de comptes",
      "numberOfAccounts": "Nombre de comptes",
      "organization": "Organisation"
    },
    "columnHeaders": {
      "client": "Client",
      "accountName": "Nom/Type de compte",
      "marketValue": "Valeur marchande"
    },
    "createAccountGroup": "Créer un groupe de comptes",
    "groupName": "Nom du groupe",
    "dragAccounts": "Glissez les comptes pour créer un groupe",
    "newGroup": "+ Nouveau groupe",
    "ungroupedAccounts": "Comptes non groupés",
    "addAccount": "Ajouter un compte",
    "searchUngroupedAccounts": "Rechercher les comptes non groupés",
    "createGroup": "Créer un groupe",
    "removeFromGroup": "Retirer du groupe",
    "deleteGroup": "Supprimer le groupe",
    "searchAccountGroupAccounts": "Rechercher les comptes du groupe",
    "viewGroup": "Voir",
    "seeMore": "Voir plus",
    "view": {
      "list": "Vue en liste",
      "group": "Vue en groupe"
    },
    "totalAccount_one": "{{count}} compte",
    "totalAccount_other": "{{count}} comptes"
  },
  "assetsOverview": {
    "marketValue": "Valeur du marché",
    "totalAssets": "Total des actifs",
    "totalSomeonesAssets": "Actifs de {{name}}",
    "cashAvailable": "Trésorerie disponible",
    "netContributions": "Contributions nettes",
    "simpleRoR": "Taux de rendement simple",
    "timeWeightedRoR": "Taux de rendement pondéré dans le temps",
    "timeWeightedRoRAbbreviation": "Taux de rendement pondéré dans le temps",
    "moneyWeightedRoR": "Rendement pondéré",
    "moneyWeightedRoRAbbreviation": "Taux de rendement pondéré",
    "cashOnHoldToWithdraw": "Trésorerie en attente de retrait",
    "cashOnHoldToTrade": "Trésorerie en attente de négociation",
    "newContributionsToday": "Nouvelles contributions (aujourd'hui)",
    "contributionsToDate": "Contributions à ce jour",
    "allocationOfTotalInvestments": "Allocation des investissements totaux",
    "holdings": "Avoirs",
    "missingExchangeRateMessage": "Le taux de change n'est pas disponible",
    "emptyChart": "Aucun historique disponible",
    "MAX": "MAX",
    "YTD": "AAJ",
    "1Y": "1A",
    "3M": "3M",
    "1M": "1M",
    "6M": "6M",
    "5Y": "5A",
    "customDateRange": "Date personnalisée"
  },
  "performanceMetricsModal": {
    "title": "Indicateurs de performance",
    "timeWeightedReturns": "Taux de rendement pondéré dans le temps (TWRR)",
    "moneyWeightedReturns": "Taux de rendement pondéré (MWRR)",
    "simpleRateOfReturn": "Taux de rendement simple",
    "fxRate": {
      "title": "Taux de change",
      "body": "{{from}} converti en {{to}} au taux suivant : {{rate}}"
    }
  },
  "coporateAccounts": {
    "govFundOptions": {
      "ADDITIONAL_CESG": "SCEE SUPPLÉMENTAIRE",
      "BASIC_CESG": "SCEE DE BASE",
      "CLB": "BEC"
    },
    "newAccount": {
      "createAccount": "Créer un compte d'entreprise",
      "selectGovernmentFund": "Sélectionner les fonds publics",
      "selectCorporateUser": "Sélectionner un utilisateur professionnel"
    },
    "relationshipOptions": {
      "PRIMARY_BENEFICIARY": "Bénéficiaire primaire",
      "CONTINGENT_BENEFICIARY": "Bénéficiaire contingent",
      "AUTHORIZED_INDIVIDUAL": "Individu autorisé",
      "OTHER": "Autre",
      "TRUSTEE": "Fiduciaire",
      "POWER_OF_ATTORNEY": "Procuration",
      "JOINT": "Conjoint",
      "BENEFICIAL_OWNER": "Propriétaire bénéficiaire",
      "SUCCESSOR": "Successeur"
    }
  },
  "incompleteFields": "Champs incomplets",
  "padAgreement": "Convention de DPA",
  "frequency": {
    "BI_WEEKLY": "Bihebdomadaire",
    "DAILY": "Quotidien",
    "LAST_DAY_OF_THE_MONTH": "Dernier jour du mois",
    "MONTHLY": "Mensuel",
    "ONE_TIME": "Une fois",
    "SEMI_MONTHLY": "Bimensuel",
    "WEEKLY": "Hebdomadaire",
    "ANNUAL": "Annuel",
    "QUARTERLY": "Trimestriel",
    "SEMESTRAL": "Semestriel"
  },
  "padAgreementTitle": "Convention de DPA",
  "canceled": "ANNULÉ",
  "accountHolder": "Titulaire du compte",
  "tradingProcessItems": {
    "INHERITED_FROM_PARENT": "Hérité de l'organisation parent",
    "NO_AUTOMATION": "Aucune automatisation",
    "PORTFOLIO_OPTIMIZER": "Optimiseur de portefeuille",
    "REBALANCE_V1": "Rééquilibrer v1",
    "REBALANCE_V2": "Rééquilibrer v2"
  },
  "tradingProcess": "Processus commercial",
  "overrideAccountsTaxRanks": "Remplacer les rangs d'imposition des comptes",
  "accountTypes": "Types de comptes",
  "overrideTaxRanks": "Annuler les rangs d'imposition",
  "defaultTaxRanks": "Rangs d'imposition par défaut",
  "other": "Autre",
  "formTypes": {
    "FORM": "Formulaire",
    "INVOICE": "Facture",
    "NOTES": "Notes",
    "OTHER": "Autre",
    "STATEMENT": "Relevé",
    "BANKING": "Banque",
    "LOGO": "Logo",
    "ID_VERIFICATION": "Preuve d'identité"
  },
  "primaryDocument": "Document principal",
  "secondaryDocument": "Document secondaire",
  "supportingDocuments": "Documents d'appui",
  "supportingDocument": "Document d'appui",
  "holdings": "Avoirs",
  "welcome": "Bienvenue",
  "affiliates": {
    "title": "Affiliés",
    "addNewAffiliate": "Ajouter un nouvel affilié"
  },
  "personalInformation": {
    "title": "Renseignements personnels"
  },
  "personOfInterest": {
    "title": "Personne d'intérêt"
  },
  "employmentInformation": {
    "title": "Situation professionnelle"
  },
  "nonIndividualInformation": {
    "title": "Renseignements non personnels"
  },
  "incomeAssetsAndDebts": {
    "title": "Actifs de revenus et dettes"
  },
  "scheduletransfers": {
    "title": "Programmer les virements"
  },
  "relationshipInformation": {
    "title": "Informations sur les relations"
  },
  "suitability": {
    "title": "Adéquation"
  },
  "reviewBankAccountInformation": {
    "title": "Vérifier les informations du compte bancaire"
  },
  "accountTable": {
    "account": "Compte",
    "name": "Nom",
    "accountHolder": "Titulaire",
    "accountNumber": "Compte #",
    "program": "Programme",
    "percentOfTotal": "% sur la totalité",
    "gainsAndLosses": "Gains/pertes non réalisés",
    "currentValue": "Valeur actuelle",
    "total": "Total"
  },
  "holdingTable": {
    "symbolName": "Symbole - Nom",
    "quantity": "Quantité",
    "bookCost": "Coût comptable",
    "currentPrice": "Prix actuel",
    "percentOfTotal": "% sur la totalité",
    "gainsAndLosses": "Gains/pertes non réalisés",
    "1DayChange": "Modification en un jour",
    "currentValue": "Valeur actuelle"
  },
  "editHousehold": {
    "edit": "Modifier",
    "editHousehold": "Modifier le ménage",
    "archive": "Archiver",
    "name": "Nom du ménage",
    "archiveHouseholdConfirmation": {
      "title": "Confirmez-vous?",
      "bodyText": "Il y a {{numOfMembers}} client(s) dans ce ménage. Cette opération ne supprime pas les renseignements relatifs au client, mais celui-ci ne sera plus associé à ce ménage."
    }
  },
  "editGoal": {
    "editGoal": "Modifier l'objectif",
    "edit": "Modifier",
    "close": "Fermer",
    "goalName": "Nom de l'objectif",
    "targetAmount": "Montant cible",
    "cancel": "Annuler",
    "closeGoal": "Confirmez-vous?",
    "closeGoalText": "Avant de fermer un objectif, vous devez fermer tous les portefeuilles associés à l'objectif."
  },
  "goalInformation": {
    "title": "Renseignements sur l'objectif"
  },
  "editSubAccount": {
    "close": "Fermer",
    "activate": "Activer",
    "cancel": "Annuler",
    "review": "Examiner",
    "closeSubAccount": "Confirmez-vous?",
    "closeSubAccountText": "Voulez-vous vraiment fermer ce portefeuille? Si vous continuez, vous ne pourrez pas effectuer de dépôts ou d'autres activités dans ce portefeuille."
  },
  "editAccount": {
    "close": "Fermer",
    "edit": "Modifier",
    "cancel": "Annuler",
    "closeAccount": "Confirmez-vous?",
    "editAccount": "Modifier le compte",
    "closeAccountText": "Avant de fermer un compte, vous devez fermer tous les portefeuilles associés au compte."
  },
  "editAccountGroup": {
    "title": "Modifier le groupe de comptes",
    "edit": "Modifier le groupe",
    "delete": "Supprimer le groupe",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "groupNameRequired": "Le nom du groupe est requis",
    "noAccountsInGroup": "Au moins un compte est requis",
    "closeAccountGroup": "Êtes-vous certain?",
    "closeAccountGroupText": "Êtes-vous certain de vouloir supprimer ce groupe de comptes?",
    "greyedAccountsCopy": "Les comptes grisés ont été fermés ou sont gelés"
  },
  "riskReturnLevels": {
    "VERY_LOW": "Très faible risque",
    "LOW": "Faible risque",
    "MEDIUM": "Risque moyen",
    "HIGH": "Haut risque",
    "VERY_HIGH": "Très haut risque"
  },
  "portfolioBreakdown": "Répartition de portefeuille",
  "currentPortfolio": "Portefeuille actuel",
  "recommendedPortfolio": "Portefeuille recommandé",
  "idVerifications": {
    "secondaryDocumentType": "Type d'information",
    "secondaryDocumentIssuingJurisdication": "Source d'information",
    "secondaryDocumentExpiryDate": "Date d'expiration",
    "secondaryDocumentID": "Référence du document",
    "secondaryDocumentUserName": "Identifiant du document secondaire",
    "clientNameOnDocument": "Nom du client sur le document",
    "documentOne": "Document 1",
    "documentTwo": "Document 2",
    "secondaryDocumentName": "Nom du document secondaire",
    "documentName": "Nom du document",
    "documentID": "Référence du document",
    "nameOnTheID": "Nom figurant sur la pièce d'identité",
    "documentType": "Type d'information",
    "creditFileSource": "Source du fichier de crédit",
    "documentIssuingJurisdication": "Source d'information",
    "expiryDate": "Date d'expiration",
    "verifiedDate": "Date de vérification",
    "idVerificationMethods": {
      "CREDIT_CHECK": "Vérification de solvabilité",
      "DIGITAL_DOCUMENT_CHECK": "Vérification de documents numériques",
      "DUAL_METHOD": "Méthode à double processus",
      "IN_PERSON_VALIDATION": "Validation en personne"
    },
    "address": "Adresse du document",
    "secondaryDocumentDateOfBirth": "Document date de naissance",
    "secondaryDocumentVerifiedDate": "Date de vérification",
    "documentOneAddress": "Document 1 : Vérification de l'adresse",
    "documentTwoDateOfBirth": "Document secondaire : Vérification de la date de naissance",
    "dateOfBirthValidation": "La date de naissance doit être dans le passé.",
    "underAgeValidation": "Le client doit être âgé d'au moins {{MINUMUM_AGE}} années.",
    "toggleDocumentA11y": "Basculer le document d'identité",
    "deleteTitle": "Supprimer la vérification de l'identité",
    "deleteBody": "Voulez-vous vraiment supprimer cet enregistrement de vérification d'identité? Cette action est irréversible.",
    "deleteDisabledNoPermission": "Vous n'avez pas l'autorisation de supprimer les vérifications d'identité",
    "turnOffVerifiedTitle": "Désactiver l'identité vérifiée",
    "turnOffVerifiedBody": "Cela marquera le client comme étant « identité non vérifiée » et lui permettra de passer à nouveau par le processus de vérification. Les dossiers de vérification d'identité existants resteront au dossier. Vous ne pouvez pas réactiver cette option à partir d'ici.",
    "turnOffVerifiedConfirm": "Désactiver"
  },
  "saveAndContinue": "Enregistrer et continuer",
  "noAffiliates": "Aucun affilié n'est assigné à ce compte",
  "bankAccount": {
    "youDontHaveAnyLinkedBankAccounts": "Vous n'avez aucun compte bancaire associé",
    "addAnotherbankAccount": "Ajouter un autre compte bancaire",
    "tdBank": "Banque Toronto-Dominion",
    "bmoBank": "Banque de Montréal",
    "scotiaBank": "Banque Scotia",
    "rbcBank": "Banque royale du Canada",
    "nationalBankOfCanada": "Banque nationale du Canada",
    "cibc": "Banque canadienne impériale de commerce",
    "hsbcBank": "Banque HSBC Canada",
    "canadaWesternTrustBank": "Banque canadienne de l'Ouest",
    "LauentianBank": "Banque Laurentienne du Canada",
    "atbBank": "Banque ATB",
    "manulifeBank": "Banque Manuvie du Canada",
    "eqLifeBank": "Banque EQ",
    "tangerineBank": "Banque Tangerine",
    "flinksBank": "Flinks",
    "coastCapitalBank": "Coast Capital",
    "desjardinsBank": "Desjardins Bank",
    "meridianBank": "Meridian Bank",
    "defaultBank": "Banque",
    "deleteBankAccountTitle": "Supprimer le compte bancaire",
    "deleteBankAccountDesc": "Voulez-vous vraiment supprimer ce compte bancaire de votre compte? Une fois supprimé, le compte devra être réajouté si vous changez d'avis.",
    "confirm": "Confirmer",
    "bankAccountName": "Surnom (facultatif)",
    "deleteAccount": "Supprimer le compte",
    "save": "Enregistrer",
    "editBankAccount": "Modifier le compte bancaire"
  },
  "taxLotDetails": "Détails du lot",
  "newTaxLotTitle": "Nouveau lot",
  "taxLotTable": {
    "openDate": "Date d'ouverture",
    "quantity": "Quantité",
    "price": "Prix",
    "costBasis": "Base de coûts",
    "marketValue": "Valeur du marché",
    "gainsLoss": "Gains/Pertes",
    "noTaxLots": "Aucun lot n'a été ajouté à ces actifs"
  },
  "newTaxLot": {
    "quantity": "Quantité",
    "price": "Prix",
    "date": "Date d'ouverture"
  },
  "portfolioTargetHoldings": "Actifs cibles du portefeuille",
  "viewFundsFacts": "Afficher les renseignements sur le fonds",
  "total": "Total",
  "additionAccountInformation": "Renseignements complémentaires sur le compte",
  "holdingsProgressTitle": "Packaging Holdings",
  "holdingsTable": {
    "symbol": "Symbole",
    "securityName": "Nom du titre",
    "quantity": "Quantité",
    "bookCostNative": "Coût comptable (devise locale)",
    "bookCost": "Coût comptable",
    "bookValue": "Valeur comptable",
    "localCost": "Coût local",
    "nativeCost": "Coût natif",
    "localBookValue": "Valeur comptable locale",
    "nativeBookValue": "Valeur comptable native",
    "custodianBookValue": "Valeur comptable du dépositaire",
    "currentPriceNative": "Prix actuel (devise locale)",
    "currentPrice": "Prix actuel",
    "unrealizedGainLossCents": "Pertes/Gains latents (en cents)",
    "unrealizedGainLossPercentage": "Pertes/Gains latents (%)",
    "oneDayChangeCents": "Variation 1 jour (en cents)",
    "oneDayChangePercentage": "Variation 1 jour (%)",
    "percentOfTotal": "% du total",
    "currentValue": "Valeur actuelle",
    "marketValueNative": "Valeur marchande (devise locale)",
    "marketValue": "Valeur marchande",
    "type": "Type",
    "name": "Nom",
    "fundSeries": "Série de fonds",
    "cusip": "CUSIP"
  },
  "previousLabel": "Précédent {{label}}",
  "expiryDateError": "La date d'expiration du document doit être dans le futur",
  "optimizerProcessItems": {
    "PORTFOLIO_OPTIMIZER_V1": "Optimiseur V1 (par défaut)",
    "PORTFOLIO_OPTIMIZER_V2": "Optimiseur V2"
  },
  "driftCalculationMethodItems": {
    "ABSOLUTE": "Absolu",
    "RELATIVE": "Relatif"
  }
}
